var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserSmallLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71456 7.99991C6.27974 7.99991 6.83223 7.83231 7.30215 7.5183C7.77207 7.20429 8.13833 6.75798 8.35459 6.23582C8.57085 5.71365 8.62741 5.13907 8.51711 4.58476C8.40682 4.03044 8.13462 3.52129 7.73494 3.12168C7.33526 2.72207 6.82605 2.44996 6.27172 2.33976C5.71739 2.22956 5.14282 2.28622 4.62069 2.50257C4.09856 2.71893 3.65231 3.08526 3.33839 3.55524C3.02446 4.02521 2.85696 4.57773 2.85706 5.14291C2.85785 5.90048 3.15918 6.62678 3.69491 7.16242C4.23063 7.69805 4.95699 7.99925 5.71456 7.99991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4525 10.3605C8.72841 9.61784 7.79936 9.10784 6.78402 8.89569C5.76869 8.68354 4.71316 8.77887 3.75226 9.16951C2.79136 9.56014 1.96873 10.2284 1.38943 11.0888C0.81013 11.9492 0.500469 12.9628 0.5 14C0.5 14.1327 0.552678 14.2598 0.646447 14.3536C0.740215 14.4474 0.867392 14.5 1 14.5H10.43C10.5626 14.5 10.6898 14.4474 10.7836 14.3536C10.8773 14.2598 10.93 14.1327 10.93 14C10.9319 13.4699 10.8501 12.9427 10.6875 12.438C10.4454 11.6579 10.0222 10.946 9.4525 10.3605Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.25C12.9236 8.25 13.875 7.2986 13.875 6.125C13.875 4.95139 12.9236 4 11.75 4C10.5764 4 9.625 4.95139 9.625 6.125C9.625 7.2986 10.5764 8.25 11.75 8.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.83496C11.0798 8.83748 10.4226 9.02001 9.84705 9.36346C9.95555 9.46046 10.065 9.55596 10.1675 9.66096C10.8484 10.3607 11.3541 11.2115 11.6435 12.144C11.7427 12.4509 11.8158 12.7657 11.862 13.085H15C15.1327 13.085 15.2598 13.0323 15.3536 12.9385C15.4474 12.8447 15.5 12.7176 15.5 12.585C15.499 11.5907 15.1036 10.6375 14.4005 9.93448C13.6975 9.23145 12.7443 8.83602 11.75 8.83496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserSmallLight);
export default __webpack_public_path__ + "static/media/ic-user-small-light.d07284dd71d441174eef0a35d3ba43f5.svg";
export { ForwardRef as ReactComponent };